var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({attrs:{"autocomplete":_vm.autocomplete,"placeholder":"you@example.com","type":"email"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }